import { Link } from "react-router-dom";
import { Users, BedDouble } from "lucide-react";

export default function BoatCard({ boat }) {
  const isComingSoon = boat.status === "coming_soon";

  const Inner = (
    <article
      data-testid={`boat-card-${boat.slug}`}
      className="group cursor-pointer"
    >
      {/* Image — natural ratio, no cropping */}
      <div className="relative overflow-hidden img-zoom-wrap">
        <img
          src={boat.heroImage}
          alt={boat.name}
          data-testid={`boat-card-image-${boat.slug}`}
          className={`w-full h-auto block transition-transform duration-700 ${
            isComingSoon ? "grayscale opacity-60" : ""
          }`}
        />

        {/* Coming soon chip */}
        {isComingSoon && (
          <span
            data-testid={`boat-coming-soon-badge-${boat.slug}`}
            className="absolute top-4 left-4 px-3 py-1 bg-[#1C1C1A]/80 backdrop-blur-sm text-white text-[0.6rem] tracking-[0.18em] uppercase font-medium"
          >
            Coming Soon
          </span>
        )}

        {/* Subtle gradient at bottom for depth */}
        {!isComingSoon && (
          <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#1C1C1A]/30 to-transparent pointer-events-none" />
        )}
      </div>

      {/* Info block — floats below image, no border box */}
      <div className="pt-4 pb-1">
        {/* Location eyebrow */}
        <p className="eyebrow text-[#6B6B65] mb-1.5">
          {boat.location.split(",")[0]}
        </p>

        {/* Name */}
        <h3 className="font-serif text-2xl sm:text-3xl font-light text-[#1C1C1A] tracking-tight leading-snug group-hover:opacity-70 transition-opacity duration-300">
          {boat.name}
        </h3>

        {/* Specs + price row */}
        <div className="mt-2.5 flex items-center gap-4 text-[0.7rem] text-[#6B6B65] uppercase tracking-wider">
          <span className="inline-flex items-center gap-1.5">
            <Users size={11} strokeWidth={1.5} />
            {boat.guests} guests
          </span>
          <span className="text-[#1C1C1A]/20">·</span>
          <span className="inline-flex items-center gap-1.5">
            <BedDouble size={11} strokeWidth={1.5} />
            {boat.bedrooms} bedroom
          </span>
        </div>

        {/* Tagline */}
        <p className="mt-2 text-[0.82rem] text-[#6B6B65] font-light leading-relaxed">
          {boat.tagline}
        </p>

        {/* CTA hint on hover — waitlist only for coming soon */}
        {isComingSoon && (
          <p className="mt-3 text-[0.68rem] uppercase tracking-[0.18em] text-[#1C1C1A] font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            Join the waitlist →
          </p>
        )}
      </div>
    </article>
  );

  if (isComingSoon) {
    return (
      <a href="#contact" data-testid={`boat-notify-${boat.slug}`}>
        {Inner}
      </a>
    );
  }

  return (
    <Link to={`/boats/${boat.slug}`} data-testid={`boat-view-${boat.slug}`}>
      {Inner}
    </Link>
  );
}
